import type { IOption } from "@components/ui-kit";
import type { ModalGetCreditDependenciesQuery } from "@src/__generated__/graphql";
import type { AppStore } from "@src/stores/AppStore";
import { currency } from "@src/utils/formatters";
import { NumberModel } from "@src/utils/models";
import { action, computed, makeObservable, observable } from "mobx";
import { Form } from "./Form";

type TCreditAccounts = NonNullable<
  NonNullable<ModalGetCreditDependenciesQuery["brand"]>["creditAccounts"]
>;

export class Store {
  @observable.ref creditAccounts: TCreditAccounts = [];
  @observable.ref form: Form;

  constructor(appStore: AppStore) {
    makeObservable(this);
    this.form = new Form(
      new NumberModel(
        0,
        appStore.workspaceStore.settings!.currency.denomination,
      ),
    );
  }

  @computed get creditAccountsOptions(): IOption[] {
    return (
      this.creditAccounts
        ?.filter((i) => i.stats.remaining_credit > 0)
        .map((creditAccount) => ({
          label: `${creditAccount.title} (${currency.formatByWorkspace(
            creditAccount.stats.remaining_credit,
          )})`,
          value: creditAccount.creditAccount.id,
        })) || []
    );
  }

  @action
  setDependencies(src: ModalGetCreditDependenciesQuery) {
    this.creditAccounts = src.brand?.creditAccounts ?? [];
  }
}
